import './DocumentControls.css'
import formatMessage from 'format-message'
import React from 'react'
import { MIN_SCALE, MAX_SCALE, SCALE_MODIFIER } from './constants'
import MenuDivider from './MenuDivider'
import RotateIcon from './icons/RotateIcon'

const isFullScreenAllowed =
  document.fullscreenEnabled ||
  document.mozFullScreenEnabled ||
  document.documentElement.webkitRequestFullScreen

export default function DocumentControls({
  documentId,
  onPageScale,
  pageNumberToAnnotationNumber,
  rotatePageClockwise,
  currentPageNum,
  toggleFullscreen,
  isFullscreen,
  currentPageScale,
  isAnnotatable,
  userRole,
}) {
  const scaleUp = () => onPageScale(SCALE_MODIFIER)
  const scaleDown = () => onPageScale(-SCALE_MODIFIER)

  const _rotatePageClockwise = () => {
    const currentPageHasNoAnnotations = pageNumberToAnnotationNumber[currentPageNum - 1] === 0

    if (currentPageHasNoAnnotations) {
      rotatePageClockwise(currentPageNum - 1)
    }
  }

  const zoomOutDisabled = currentPageScale <= MIN_SCALE + SCALE_MODIFIER
  const zoomInDisabled = currentPageScale >= MAX_SCALE - SCALE_MODIFIER
  const fullscreenButtonText = isFullscreen
    ? formatMessage('Exit Full Screen')
    : formatMessage('Enter Full Screen')

  const currentPageHasAnnotations = pageNumberToAnnotationNumber[currentPageNum - 1] > 0

  return (
    <nav className="DocumentControls" style={{ marginRight: '12px' }}>
      <div
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          userSelect: 'none',
        }}
      >
        {documentId &&
          ((userRole && !(isAnnotatable && userRole === 'student')) || !isAnnotatable) && (
            <button
              className="AnnotationControlButton"
              aria-label={formatMessage('Rotate Page Clockwise By 90 Degrees')}
              title={formatMessage('Rotate Page Clockwise By 90 Degrees')}
              onClick={_rotatePageClockwise}
              disabled={currentPageHasAnnotations}
            >
              <div className="AnnotationControlButton-outer">
                <div className="AnnotationControlButton-inner">
                  <RotateIcon />
                </div>
              </div>
            </button>
          )}
        <MenuDivider style={{ marginLeft: '8px', marginRight: '4px' }} />
        <button
          className="AnnotationControlButton"
          aria-label={formatMessage('Zoom Out')}
          title={formatMessage('Zoom Out')}
          disabled={zoomOutDisabled}
          aria-disabled={zoomOutDisabled}
          onClick={scaleDown}
        >
          <div className="AnnotationControlButton-outer">
            <div className="AnnotationControlButton-inner">
              <svg width="14" height="2" viewBox="0 0 14 2">
                <path d="M0 0h14v2H0z" fill="#F5F5F5" fillRule="evenodd" />
              </svg>
            </div>
          </div>
        </button>
        <span
          style={{
            textTransform: 'uppercase',
            fontSize: '0.75rem',
            color: '#EEEEEF',
            marginLeft: '4px',
            marginRight: '4px',
          }}
          aria-hidden="true"
        >
          {formatMessage('Zoom')}
        </span>
        <button
          className="AnnotationControlButton"
          aria-label={formatMessage('Zoom In')}
          title={formatMessage('Zoom In')}
          disabled={zoomInDisabled}
          aria-disabled={zoomInDisabled}
          onClick={scaleUp}
        >
          <div className="AnnotationControlButton-outer">
            <div className="AnnotationControlButton-inner">
              <svg width="14" height="14" viewBox="0 0 14 14">
                <path d="M8 6V0H6v6H0v2h6v6h2V8h6V6H8z" fill="#F5F5F5" />
              </svg>
            </div>
          </div>
        </button>
      </div>
      <MenuDivider style={{ marginLeft: '8px', marginRight: '4px' }} />

      {isFullScreenAllowed && (
        <div className="ViewerControls--page-controls">
          <button
            aria-label={fullscreenButtonText}
            className="AnnotationControlButton full-screen-button"
            onClick={toggleFullscreen}
            title={fullscreenButtonText}
          >
            <div className="AnnotationControlButton-outer">
              <div className="AnnotationControlButton-inner">
                {isFullscreen ? (
                  <svg width="17px" height="17px" viewBox="0 0 17 17">
                    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                      <g transform="translate(-698.000000, -930.000000)" fill="#2B3B46">
                        <path
                          d="M713.690612,930 L715.000371,931.309759 L710.33285,935.977279 L713.335847,935.977279 L713.335847,937.830763 L707.169607,937.830763 L707.169607,931.663597 L709.023092,931.663597 L709.023092,934.66752 L713.690612,930 Z M699.663597,939.170163 L705.829837,939.170163 L705.829837,945.335476 L703.978205,945.335476 L703.978205,942.33248 L699.309759,947 L698,945.690241 L702.668447,941.022721 L699.663597,941.022721 L699.663597,939.170163 Z"
                          fill="#F5F5F5"
                        />
                      </g>
                    </g>
                  </svg>
                ) : (
                  <svg width="17px" height="17px" viewBox="0 0 17 17">
                    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                      <polygon
                        points="10.1523248 -0.000102881281 10.1523248 2.05752274 13.4887648 2.05752274 2.05762562 13.4876331 2.05762562 10.1522219 0 10.1522219 0 17 6.84983569 17 6.84983569 14.9423744 3.51236694 14.9423744 14.9435061 3.51226405 14.9435061 6.848704 17.0001029 6.848704 17.0001029 -0.000102881281"
                        fill="#F5F5F5"
                      />
                    </g>
                  </svg>
                )}
              </div>
            </div>
          </button>
          <MenuDivider style={{ marginLeft: '8px', marginRight: '4px' }} />
        </div>
      )}
    </nav>
  )
}
